import { useCallback, useState } from 'react';
import { NO_GROUPING } from './useMonthInvoices';

export const DISPLAY_MODE_STORAGE_KEY = 'invoice-list-display-mode';
// Every invoice on its own row, by company, by group of companies (JBWEB-1309).
export const DISPLAY_MODES = [NO_GROUPING, 'company', 'group'];

// Storage may be refused (private browsing, quota, policy): the list then
// opens flat and the choice lasts as long as the page.
const readStoredMode = () => {
  try {
    const stored = window.localStorage.getItem(DISPLAY_MODE_STORAGE_KEY);
    return DISPLAY_MODES.includes(stored) ? stored : NO_GROUPING;
  } catch {
    return NO_GROUPING;
  }
};

const storeMode = (mode) => {
  try {
    window.localStorage.setItem(DISPLAY_MODE_STORAGE_KEY, mode);
  } catch {
    // Kept for this visit only.
  }
};

/**
 * How the admin sees the invoice list (JBWEB-1309): flat, by company or by
 * group. A preference of the browser, not of the month or of the filters: it
 * outlives them, and the visit of the tab.
 */
const useInvoiceDisplayMode = () => {
  const [displayMode, setDisplayMode] = useState(readStoredMode);

  const changeDisplayMode = useCallback((mode) => {
    if (!DISPLAY_MODES.includes(mode)) return;
    setDisplayMode(mode);
    storeMode(mode);
  }, []);

  return { displayMode, onDisplayModeChange: changeDisplayMode };
};

export default useInvoiceDisplayMode;
